<template>
  <router-view />
</template>

<script>
export default {
  name: "AdministratorComponent",
  beforeRouteEnter(to, from, next) {
    next((v) => {
      v.$store.dispatch("Administrator/getUsers");
    });
  },
};
</script>

<style scoped></style>
